var map = {
	"./activate-card.svg": 1109,
	"./app-store-btn.svg": 1093,
	"./appui.svg": 1158,
	"./arrows/rightArrowBlue.svg": 360,
	"./arrows/rightArrowGreen.svg": 869,
	"./attachment_export.svg": 1114,
	"./background/analytics-side-banner.svg": 1163,
	"./background/bills-page-bg.svg": 1762,
	"./background/microsoft.svg": 1186,
	"./background/myob.svg": 1187,
	"./background/quickbooks.svg": 1188,
	"./background/sage.svg": 1189,
	"./bank-indonesia.svg": 1157,
	"./bankAccActive.svg": 1025,
	"./bankAccGrey.svg": 1024,
	"./banner-default-info.svg": 1173,
	"./banner/fundingIcon.svg": 1763,
	"./banner/sideBanner.svg": 995,
	"./bill-approval-flow.svg": 1168,
	"./bill-discard.svg": 1185,
	"./bill-importFromXero.svg": 1087,
	"./bill-invoice-active.svg": 1144,
	"./bill-invoice-inactive.svg": 1145,
	"./bills-email.svg": 1082,
	"./bills-emailIcon.svg": 1086,
	"./bills-multiple-upload.svg": 1083,
	"./bills-uploadBulk.svg": 1084,
	"./bills-uploadInvoice.svg": 1085,
	"./blue-close-circle.svg": 1141,
	"./blue-info-circle.svg": 1062,
	"./brand-three-dot.svg": 1150,
	"./bulb-tooltip-small.svg": 1164,
	"./bulb-tooltip.svg": 1764,
	"./card-circle-icon.svg": 1089,
	"./carouselLeftIcon.svg": 1045,
	"./carouselRightIcon.svg": 1046,
	"./cashReimburse.svg": 1023,
	"./changeFile.svg": 1080,
	"./chat-article-icon.svg": 1018,
	"./chat-icon.svg": 1017,
	"./chat-widget-bg.svg": 1765,
	"./checklist-blue.svg": 1066,
	"./checklist-white.svg": 1067,
	"./checkmark.svg": 1766,
	"./chevron-down-approval.svg": 1167,
	"./chevron-down-orange.svg": 1178,
	"./chevron-right.svg": 1767,
	"./chevron-up-orange.svg": 1179,
	"./chevron_down.svg": 1129,
	"./circle-close.svg": 1049,
	"./circle-cross.svg": 678,
	"./circle-tick.svg": 677,
	"./clipboard.svg": 1768,
	"./close-grey.svg": 1050,
	"./close-icon-white.svg": 870,
	"./close-icon.svg": 1051,
	"./close-icon_bkg.svg": 679,
	"./close-light_grey.svg": 1052,
	"./coming_soon.svg": 991,
	"./copyIcon.svg": 1037,
	"./csv-export.svg": 1113,
	"./csv-icon.svg": 1032,
	"./csv.svg": 1769,
	"./data-table-no-record-found.svg": 1160,
	"./deleteFile.svg": 1081,
	"./discard-edit.svg": 1172,
	"./document-error.svg": 1175,
	"./document-loading-blue.svg": 1174,
	"./document-loading-green.svg": 1176,
	"./document_in_review.svg": 1103,
	"./document_uploaded.svg": 1102,
	"./doument_pending.svg": 1101,
	"./down-arrow-black.svg": 1130,
	"./down-arrow-grey.svg": 1131,
	"./down-arrow-white.svg": 1047,
	"./downArrowLg.svg": 1058,
	"./download.svg": 1060,
	"./editIcon.svg": 1065,
	"./ellipsis.svg": 1770,
	"./email-sent.svg": 989,
	"./empty-card-state.svg": 1135,
	"./empty-cards.svg": 998,
	"./empty_coming_soon.svg": 1161,
	"./empty_default.svg": 1143,
	"./enterLeft.svg": 1074,
	"./error-icon.svg": 990,
	"./error.svg": 1771,
	"./exclamation-black.svg": 1177,
	"./exclamationIcon.svg": 1064,
	"./external-link.svg": 1183,
	"./failedIcon.svg": 1013,
	"./featureCheck.svg": 1181,
	"./file.svg": 1031,
	"./file_not_found.svg": 994,
	"./filter-icon.svg": 1020,
	"./flagID.svg": 1772,
	"./flagSG.svg": 1773,
	"./flash.svg": 1774,
	"./flow_add.svg": 1122,
	"./flow_condition.svg": 1121,
	"./flow_condition_amount.svg": 1125,
	"./flow_condition_category.svg": 1126,
	"./flow_condition_wallet.svg": 1124,
	"./flow_end.svg": 1123,
	"./flow_start.svg": 1120,
	"./google-play-btn.svg": 1092,
	"./googleAuthenticatorLogo.svg": 871,
	"./hideItems.svg": 1079,
	"./home/empty-default-icon.svg": 1132,
	"./home/tiny-empty-coming-soon-without-background.svg": 1140,
	"./home/tiny-empty-coming-soon.svg": 1139,
	"./homeIcons/addEmployee.svg": 1201,
	"./homeIcons/bankAccount.svg": 1202,
	"./homeIcons/categories.svg": 1203,
	"./homeIcons/employee.svg": 1204,
	"./homeIcons/ic_bills.svg": 1205,
	"./homeIcons/ic_bills_grey.svg": 1206,
	"./homeIcons/ic_billsapproval.svg": 1207,
	"./homeIcons/ic_chevron.svg": 1208,
	"./homeIcons/ic_fundtransfer.svg": 1209,
	"./homeIcons/ic_request.svg": 1210,
	"./homeIcons/ic_request_grey.svg": 1211,
	"./homeIcons/ic_submit_bills_grey.svg": 1212,
	"./homeIcons/internalRequest.svg": 1775,
	"./homeIcons/manageBills.svg": 1213,
	"./homeIcons/pendingcard.svg": 1214,
	"./homeIcons/reimbursement.svg": 1215,
	"./homeIcons/requestMoney.svg": 1216,
	"./homeIcons/sendMoney.svg": 1217,
	"./homeIcons/submitBills.svg": 1218,
	"./homeIcons/teams.svg": 1219,
	"./homeIcons/transaction.svg": 1220,
	"./ic_info.svg": 1098,
	"./ic_info_outline.svg": 1099,
	"./ic_info_outline_grey.svg": 1100,
	"./ic_overflow.svg": 1106,
	"./ic_upload-image.svg": 1155,
	"./ico_team.svg": 1162,
	"./icons/close-grey.svg": 1776,
	"./icons/creditcardIcon.svg": 1027,
	"./icons/deleteIcon.svg": 1068,
	"./icons/downArrowIconGrey.svg": 1048,
	"./icons/fundingIcon.svg": 1022,
	"./icons/green-tick-bold-icon.svg": 1070,
	"./icons/green-tick-icon16x16.svg": 1069,
	"./icons/info.svg": 1147,
	"./icons/lock-orange-48x48.svg": 1095,
	"./icons/no-internet-orange-48x48.svg": 1097,
	"./icons/no-sms-orange-48x48.svg": 1096,
	"./icons/paylah.svg": 1007,
	"./icons/people-icon.svg": 997,
	"./icons/people.svg": 1006,
	"./icons/receipts-grey.svg": 1777,
	"./icons/receipts.svg": 1015,
	"./icons/right-arrow-white-16x16.svg": 1071,
	"./icons/saasIcon.svg": 1021,
	"./icons/spendMoneyIcon.svg": 1026,
	"./icons/success-upload-icon.svg": 1000,
	"./icons/team-icon.svg": 996,
	"./icons/tick-mark-green-16x12.svg": 1094,
	"./icons/triangle-error-grey-24x24.svg": 1142,
	"./icons/upload-image-icon.svg": 999,
	"./icons/user.svg": 1005,
	"./icons/viewall.svg": 1039,
	"./icons/visa-icon.svg": 987,
	"./info.svg": 1063,
	"./infoFilled.svg": 1778,
	"./integrations/xero/addBankAccountillustration.svg": 1221,
	"./integrations/xero/addItAnywaysillustration.svg": 1222,
	"./integrations/xero/bankAccountDetailsillustration.svg": 1223,
	"./integrations/xero/emptyFolderIcon.svg": 1224,
	"./integrations/xero/xeroLogo.svg": 1225,
	"./itemsStacked.svg": 1061,
	"./kyb/ic_upload.svg": 1226,
	"./kyb/myInfo.svg": 1227,
	"./kyb/myInfoBtn.svg": 1228,
	"./kyb/singPass.svg": 1229,
	"./landing-soon.svg": 1170,
	"./left-arrow-grey.svg": 1044,
	"./left-arrow.svg": 1779,
	"./leftArrow.svg": 1041,
	"./leftArrowOrange.svg": 1040,
	"./limit-exceeded-info.svg": 1171,
	"./lock_icon.svg": 1038,
	"./login_bg.svg": 992,
	"./login_sidebar_bg.svg": 1780,
	"./logo_name_orange.svg": 981,
	"./logo_orange.svg": 983,
	"./logo_symbol_orange.svg": 1781,
	"./mastercardLogo.svg": 988,
	"./merchantIcons/acra.svg": 1230,
	"./merchantIcons/adobe.svg": 1231,
	"./merchantIcons/amazon.svg": 1232,
	"./merchantIcons/atlassian.svg": 1233,
	"./merchantIcons/clickup.svg": 1234,
	"./merchantIcons/comfort.svg": 1235,
	"./merchantIcons/deliveroo.svg": 1236,
	"./merchantIcons/facebook.svg": 1237,
	"./merchantIcons/figma.svg": 1238,
	"./merchantIcons/foodpanda.svg": 1239,
	"./merchantIcons/gogox.svg": 1240,
	"./merchantIcons/gojek.svg": 1241,
	"./merchantIcons/google.svg": 1242,
	"./merchantIcons/grab.svg": 1243,
	"./merchantIcons/hubspot.svg": 1244,
	"./merchantIcons/lazada.svg": 1245,
	"./merchantIcons/linkedIn.svg": 1246,
	"./merchantIcons/mailchimp.svg": 1247,
	"./merchantIcons/microsoft.svg": 1248,
	"./merchantIcons/netflix.svg": 1249,
	"./merchantIcons/pickupp.svg": 1250,
	"./merchantIcons/shippit.svg": 1251,
	"./merchantIcons/shopee.svg": 1252,
	"./merchantIcons/shopify.svg": 1253,
	"./merchantIcons/spotify.svg": 1254,
	"./merchantIcons/stockxX.svg": 1255,
	"./merchantIcons/techInasia.svg": 1256,
	"./merchantIcons/tiktok.svg": 1257,
	"./merchantIcons/twilio.svg": 1258,
	"./merchantIcons/typeform.svg": 1259,
	"./merchantIcons/uber.svg": 1260,
	"./merchantIcons/udemy.svg": 1261,
	"./merchantIcons/upwork.svg": 1262,
	"./merchantIcons/xero.svg": 1263,
	"./merchantIcons/zoom.svg": 1264,
	"./mini-spot-activate-icon.svg": 1134,
	"./mini-spot-search-icon.svg": 1133,
	"./minus.svg": 1056,
	"./navigate-up.svg": 1782,
	"./navigation-dots-vertical.svg": 1159,
	"./new-tab.svg": 1118,
	"./notfound.svg": 1110,
	"./notification.svg": 1783,
	"./ocr-union-green.svg": 1166,
	"./ocr-union.svg": 1165,
	"./orange-tick.svg": 1146,
	"./orange-yellow-gradient-bg.svg": 1090,
	"./paylah-orange.svg": 1010,
	"./paylah.svg": 1784,
	"./paynow-active.svg": 1028,
	"./paynow-inactive.svg": 1029,
	"./pdf-export.svg": 1112,
	"./pdf.svg": 1030,
	"./pendingIcon.svg": 1014,
	"./people.svg": 1785,
	"./physical-card.svg": 1108,
	"./plus-dark.svg": 1055,
	"./plus-red-icon.svg": 1136,
	"./plus.svg": 1053,
	"./plusIconOrange.svg": 1054,
	"./pt-aryadana.svg": 1156,
	"./queuedIcon.svg": 1011,
	"./raw-icon.svg": 1033,
	"./re-kyb-alert.svg": 1184,
	"./receipts-grey.svg": 1016,
	"./red-info.svg": 1786,
	"./refresh-2.svg": 1787,
	"./refresh-fxrate.svg": 1148,
	"./refresh.svg": 1036,
	"./reimbursement-approval-flow.svg": 1169,
	"./reject-approval-request.svg": 1149,
	"./request-money.svg": 1009,
	"./retriveSingpass.svg": 1182,
	"./right-arrow-dark.svg": 1042,
	"./rightArrow.svg": 1788,
	"./rightArrowWhiteLg.svg": 1059,
	"./right_arrow.svg": 1043,
	"./right_arrow_lg.svg": 1057,
	"./rounded-right-arrow-blue.svg": 1138,
	"./search-black-50.svg": 1035,
	"./search.svg": 1034,
	"./send-money.svg": 1008,
	"./showItems.svg": 1078,
	"./singpass.svg": 1180,
	"./smart-csv-export.svg": 1111,
	"./smartcsv/jurnal.svg": 1116,
	"./smartcsv/quickbooks.svg": 1117,
	"./smartcsv/xero.svg": 1115,
	"./spenmo-desktop.svg": 872,
	"./spenmo-icon-bordered.svg": 1091,
	"./spenmo-logo-orange-compact.svg": 986,
	"./spenmo-logo-orange.svg": 985,
	"./spenmo-name-logo.svg": 982,
	"./spenmo_logo_white.svg": 984,
	"./success-icon.svg": 993,
	"./syncedIcon.svg": 1012,
	"./three-dot.svg": 1789,
	"./three_dots.svg": 1127,
	"./tiny_error.svg": 1104,
	"./tiny_success.svg": 1105,
	"./tnc-active.svg": 1073,
	"./tnc-inactive.svg": 1072,
	"./toaster-circle-tick.svg": 1151,
	"./toaster-error-close.svg": 1154,
	"./toaster-error.svg": 1152,
	"./toaster-success-close.svg": 1153,
	"./transactions-empty.svg": 1790,
	"./trash.svg": 1128,
	"./upload.svg": 1019,
	"./upload/heic-heif-file-type.svg": 1003,
	"./upload/jpg-file-type.svg": 1002,
	"./upload/pdf-file-type.svg": 1004,
	"./upload/png-file-type.svg": 1001,
	"./uploadCompleted.svg": 1076,
	"./uploadCompletedWithError.svg": 1077,
	"./uploadInvoice.svg": 1075,
	"./uploadReceiptIcon.svg": 1088,
	"./user.svg": 1791,
	"./virtual-card.svg": 1107,
	"./visa-icon-small.svg": 1137,
	"./white-eye.svg": 1119,
	"./xeroLogo.svg": 979,
	"./zendesk-logo.svg": 980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1761;